import { encrypt } from '@/common/securityUtils';

export type PointAgentTab = 'affiliate' | 'club' | 'customer';

const pointAgentTypeMap: Record<PointAgentTab, string> = {
  affiliate: '6',
  club: '4',
  customer: '3',
};

export const getEncryptedPointAgentType = (tab: PointAgentTab): string => encrypt(pointAgentTypeMap[tab]);
